import React from 'react'
import Development from './Development';

function Home() {
  return (
    <>
    <Development />
    </>
  )
}

export default Home